import { useMemo } from 'react'

import Loading from '~/components/Loading'
import CampaignPlacesTable from '~/modules/retailMedia/components/_tables/CampaignPlacesTable'
import Investment from '~/modules/retailMedia/components/CampaignForm/elements/Investment'
import { CampaignInsertionOrderPanel } from '~/modules/retailMedia/components/CampaignInsertionOrderPanel'
import CampaignSubpublishers from '~/modules/retailMedia/components/CampaignSubpublishers'
import DailyHistoryTable from '~/modules/retailMedia/components/DailyHistoryTable'
import { InfoView } from '~/modules/retailMedia/components/InfoView'
import { StatusBar } from '~/modules/retailMedia/components/StatusBar'
import StatusHistory from '~/modules/retailMedia/components/StatusHistory'

import DigitalSignageDetails from '../DigitalSignageDetails'
import MetricsCampaignView from '../Metrics'

const ViewSponsoredBrandCampaign: React.FC<ViewCampaignProps> = ({
  data,
  loading
}) => {
  const statusBarOnTop = [
    'pending_review',
    'rejected',
    'approved',
    'awaiting_publication'
  ].includes(data.status)

  const shouldShowMetrics = useMemo(
    () => data?.target === 'invian',
    [data?.target]
  )

  return (
    <>
      {statusBarOnTop && (
        <StatusBar
          status={data?.status}
          message={
            data?.status_history?.length > 0
              ? data?.status_history[0]?.note
              : ''
          }
        />
      )}

      {shouldShowMetrics && (
        <MetricsCampaignView
          adType={data?.adType}
          target={data?.target}
          selectQuantity={1}
          initialMetrics={['impressions']}
        />
      )}

      <Loading status={loading}>Carregando dados da campanha...</Loading>

      <DigitalSignageDetails data={data} />

      <hr />

      {shouldShowMetrics && (
        <DailyHistoryTable
          campaignType={data?.adType}
          campaignStartDate={data?.raw?.start_at}
          target={data?.target}
        />
      )}

      <CampaignSubpublishers
        publisherId={data.publisher.id}
        campaignData={data}
      />

      <InfoView data={data} />

      <hr />

      <CampaignPlacesTable campaignId={data.id} />

      <hr />

      <CampaignInsertionOrderPanel
        campaignId={data.id}
        insertionOrders={data.insertionOrders}
      />

      <Investment
        campaignId={data?.id}
        initialData={data?.raw}
        adCostType={data?.raw?.cost_type}
      />

      <StatusBar
        status={data?.status}
        message={
          data?.status_history?.length > 0 ? data?.status_history[0]?.note : ''
        }
      />

      <hr />

      <StatusHistory data={data?.status_history} />
    </>
  )
}
export default ViewSponsoredBrandCampaign
